/* eslint-disable react/react-in-jsx-scope */

import { useLocation } from "react-router-dom";
import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";

const PanoramaPage = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const imgUrl = queryParams.get('imgurl');

    return (
        <div>
{imgUrl?<ReactPhotoSphereViewer
            height={"100vh"}
            loadingTxt={"Loading..."}
            src={imgUrl}
            width={"100%"}
          ></ReactPhotoSphereViewer> : <h2>이미지가 없습니다.</h2>}
           
        </div>
    )
}

export default PanoramaPage;